<template>
  <div class="searches-dt-container">
    <v-data-table
      v-model="selectedSearch"
      :headers="headers"
      :items="searches"
      item-key="formatted.id"
      :items-per-page="1000"
      sort-by="formatted.name"
      :sort-desc="false"
      :height="400"
      fixed-header
      :loading="loading"
      show-select
      single-select
      :show-expand="showExpand"
      :footer-props="{
        itemsPerPageOptions: [],
      }"
      @item-selected="handleItemSelected"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="5" class="pl-5">
          {{
            item.formatted.description
              ? item.formatted.description
              : `No description found for: ${item.formatted.name}`
          }}
        </td>
      </template>
      <template v-slot:item.creationTime="{ item }">
        {{ item.formatted.creationTime }}
      </template>
      <template v-slot:item.lastUpdateTime="{ item }">
        {{ item.formatted.lastUpdateTime }}
      </template>
      <template v-slot:no-data>
        <div class="my-5">
          There are currently no searches you created that don't already have an
          alert.
        </div>
      </template>
      <template v-slot:no-results>
        <div class="my-5">
          There are currently no searches you created that don't already have an
          alert.
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import lodashSortBy from "lodash/sortBy";
import lodashCloneDeep from "lodash/cloneDeep";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_SAVED_SEARCH } from "@/store";
import { GET_SAVED_SEARCH_QUERIES } from "@/store/actions.type";
import {
  DEFAULT_NOTIFICATION,
  NOTIFICATION_TYPE_SAVED_SEARCH,
  NOTIFICATION_FREQUENCY_IMMEDIATELY,
  NOTIFICATION_EXPIRATION_ID_NEVER,
} from "@/common/constants/notifications";
import { getNotifications } from "@/services/notifications/notifications.service";

const EMITTED_ACTIONS = {
  SELECT: "select",
};

export default {
  name: "SearchesList",
  props: {
    selected: {
      type: Object,
    },
  },
  data() {
    return {
      selectedSearch: [],
      searches: [],
      notifications: [],
      loading: false,
      headers: [
        {
          text: "Name",
          value: "formatted.name",
          sortable: true,
          width: 200,
        },
        {
          text: "Created",
          value: "formatted.creationTime",
          sortable: true,
          width: 100,
        },
        {
          text: "Updated",
          value: "formatted.lastUpdateTime",
          sortable: true,
          width: 100,
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    await this.getNotifications();
    await this.$store.dispatch(
      MODULE_PREFIX_SAVED_SEARCH + GET_SAVED_SEARCH_QUERIES,
      {}
    );

    if (this.queries) {
      const queries = [];
      this.queries.forEach((query) => {
        if (this.featureUnlocked("saved-search-new-api")) {
          if (
            !this.notifications.some(
              (n) => query.searchNotificationId === n.searchNotificationId
            )
          ) {
            queries.push(query);
          }
        } else if (!query.frequency && query.ownerId === query.userId) {
          queries.push(query);
        }
      });
      this.searches = lodashSortBy(queries, [
        (query) => query.name.toLowerCase(),
      ]);
    }
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      queries: MODULE_PREFIX_SAVED_SEARCH + "queries",
      savedSearchDetails: MODULE_PREFIX_SAVED_SEARCH + "savedSearchDetails",
    }),
    showExpand() {
      return false;
    },
  },
  methods: {
    handleItemSelected(selected) {
      let notification = lodashCloneDeep(DEFAULT_NOTIFICATION);
      if (selected?.item?.formatted?.id && selected?.value) {
        notification = lodashCloneDeep(selected.item);
      }
      notification.formatted = notification.formatted || {};
      notification.formatted.docType = NOTIFICATION_TYPE_SAVED_SEARCH;
      notification.formatted.frequency = NOTIFICATION_FREQUENCY_IMMEDIATELY;
      notification.formatted.expiration = NOTIFICATION_EXPIRATION_ID_NEVER;
      notification.formatted.expirationDate = null;
      this.$emit(EMITTED_ACTIONS.SELECT, notification);
    },
    async getNotifications() {
      this.notifications = await getNotifications({
        type: [{ value: NOTIFICATION_TYPE_SAVED_SEARCH }],
      });
    },
  },
  watch: {
    selected: {
      handler() {
        if (
          this.selected?.formatted?.id &&
          this.selectedSearch?.formatted?.id &&
          this.selected.formatted.id !== this.selectedSearch.formatted.id
        ) {
          this.selectedSearch = [this.selected];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
.searches-dt-container .v-data-table tbody tr.v-data-table__expanded__content {
  -webkit-box-shadow: none !important; /*inset 0px 4px 8px -5px rgba(50, 50, 50, 0.75), inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75); */
  box-shadow: none !important; /*inset 0px 4px 8px -5px rgba(50, 50, 50, 0.75), inset 0px -4px 8px -5px rgba(50, 50, 50, 0.75); */
}
</style>
